import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/deliveryOrder',
    meta: { title: '提货订单管理' },
    component: Layout,
    redirect: '/deliveryOrder/list',
    children: [
      {
        path: 'list',
        meta: { title: '提货订单管理', activeMenu: '/deliveryOrder' },
        component: () => import('@/views/deliveryOrder/DeliveryOrder.vue')
      },
      {
        path: 'detail',
        meta: { title: '提货订单详情', activeMenu: '/deliveryOrder' },
        component: () => import('@/views/deliveryOrder/DeliveryOrderDetail.vue')
      }

    ]
  }

]
